// extracted by mini-css-extract-plugin
module.exports = {"alert":"styles__alert___iCacS","icon":"styles__icon___3WRi0","spacer":"styles__spacer___mdB7u"};